module.exports = __webpack_public_path__ + "static/img/intro-pic2@3x.49bfdf46.jpg";